module.exports = __webpack_public_path__ + "assets/images/pages/hearthy/hearthy-1.webp?e8ec496e";